<template>
  <div class="container2">
    <div id="print">
      <div class="header shop_header" v-if="isShopView">
        <div class="order_no flex_col">
          <h1>网上商城订货单</h1>
          <h3>订单号：{{ detailObj.orderBatchNo }}</h3>
        </div>
      </div>
      <div class="header" v-else>
        <div class="logo flex_col">
          <img class="img_item" src="@/assets/img/LOGO.png" />
          <h1>www.duobihouse.com</h1>
        </div>
        <div class="order_no flex_col">
          <h1>多比网商城订货单</h1>
          <h3>订单号：{{ detailObj.orderBatchNo }}</h3>
        </div>
      </div>
      <div class="user">
        <div class="content">
          <p class="item">客户名称：{{detailObj.consignee}}</p>
          <p class="item">下单时间：{{detailObj.createTime}}</p>
        </div>
        <div class="content">
          <p class="item">联系方式：{{detailObj.consigneeTel}}</p>
          <p class="item">付款状态：{{detailObj.payStatus | filPayStatus}}</p>
        </div>
        <div class="content">
          <p>交货时间：{{detailObj.goodsWishSendTime}}</p>
        </div>
        <div class="content">
          <p>收货地址：
            {{detailObj.deliveryProName || ''}}
            {{detailObj.deliveryCityName || ''}}
            {{detailObj.deliveryDisName || ''}}
            {{detailObj.deliveryTownName || ''}}
            {{detailObj.deliveryAddr || ''}}
          </p>
        </div>
      </div>
      <p class="tip">您好，您总共订购了<span class="bold"> {{goodsNumber}} </span>件商品，明细如下：</p>
      <div class="table">
        <div class="head">
          <p class="goods_img">商品图片</p>
          <p class="goods">商品名称</p>
          <p>商品货号</p>
          <p class="size">商品尺寸(mm)</p>
          <p>单价(元)</p>
          <p>数量</p>
          <p>小计(元)</p>
          <p>备注</p>
        </div>
        <!-- 商品列表 -->
        <ul class="table-list">
          <li class="item-li" v-for="(item, index) in orderGoodsBrandList" :key="index">
            <!-- :class="{page:(item.goodsMixList.length>2 && item.goodsMixList.length<5 && index===0) || (item.goodsMixList.length>6 && index!=0)}" -->

            <div class="first_name">
              {{item.goodsBrandName}}
            </div>
            <div class="goods-list" v-for="(order, i) in item.goodsMixList" :key="i">
              <div class="item img">
                <img v-lazy="order.mainPreviewImageFilePath" />
              </div>
              <div class="item name">
                <p class="scale">{{ order.goodsName + " " + order.goodsMixName }}</p>
              </div>
              <div class="item">
                <p class="scale">{{ order.goodsMixNo }}</p>
              </div>
              <div class="item size">
                <p class="scale" v-if="order.mixGoodsLength && order.mixGoodsWidth && order.mixGoodsHeight">
                  长{{order.mixGoodsLength}}*宽{{order.mixGoodsWidth}}*高{{order.mixGoodsHeight}}
                </p>
              </div>
              <div class="item">
                <p class="scale">{{ order.salePrice | priceValue }}</p>
              </div>
              <div class="item">
                <p class="scale">{{ order.buyCount }}</p>
              </div>
              <div class="item">
                <p class="scale">{{ order.salePrice*order.buyCount | priceValue }}</p>
              </div>
              <div class="item word_break">
                <p class="scale">{{ order.remark }}</p>
              </div>
            </div>

          </li>
        </ul>
      </div>
      <div class="order-total">
        <div class="total-box">
          <div class="total">
            <span>商品总金额：</span>
            <b v-if="detailObj.originalFee != undefined">¥ {{ parseInt(detailObj.originalFee) | priceValue}}</b>
          </div>
          <div class="total">
            <span>服务费：</span>
            <b v-if="detailObj.totalServiceFee != undefined">¥ {{ detailObj.totalServiceFee | priceValue}}</b>
          </div>
          <div class="total bold">
            <span>订单总金额：</span>
            <b class="bold" v-if="detailObj.orderTotalFee != undefined">¥ {{ parseInt(detailObj.orderTotalFee) | priceValue}}</b>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-box">
      <el-button class="btn" type="primary" @click="print">打印</el-button>
    </div>
  </div>
</template>

<script>
const payStatusList = {
  1: "待付款",
  2: "部分付款",
  3: "已付全款",
};
export default {
  // 动态使用meta name
  metaInfo: { title: "打印订单" },
  name: "printOrder",
  props: {
    GetShopOrderDetail: {
      type: Function,
      default: () => {},
    },
    isShopView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      orderBatchId: null,
      detailObj: {},
      orderGoodsBrandList: [], //订单列表
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      this.orderBatchId = this.$route.query.id;
      let params = { orderBatchId: this.orderBatchId };
      this.GetShopOrderDetail(params).then((res) => {
        this.detailObj = res.data[0];
        this.detailObj.orderGoodsBrandList.forEach((item) => {
          if (item.orderStatus != 3) {
            this.orderGoodsBrandList.push(item);
          }
        });
      });
    },
    print() {
      let printHTML = document.getElementById("print").innerHTML;
      window.document.body.innerHTML = printHTML;
      window.print();
      location.reload();
    },
  },
  computed: {
    goodsNumber() {
      let num = 0;
      this.orderGoodsBrandList.forEach((item) => {
        item.goodsMixList.forEach((v) => {
          num += v.buyCount;
        });
      });
      return num;
    },
  },
  filters: {
    filPayStatus(val) {
      return payStatusList[val];
    },
  },
};
</script>

<style lang="less" scoped>
@page {
  size: auto A4 landscape;
  margin-top: 8mm;
  margin-bottom: 6mm;
  // padding-bottom: 20cm;
}
.container2 {
  width: 1124px;
  margin: 0 auto;
}
#print {
  padding: 0 50px;
}
.header {
  padding: 30px 24px;
  padding-right: 70px;
  display: flex;
  justify-content: space-between;
  .flex_col {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .logo {
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    h1 {
      font-size: 12px;
      font-weight: 400;
      line-height: 20px;
    }
    .img_item {
      width: auto;
      height: auto;
    }
  }
  .order_no {
    h1 {
      padding-top: 18px;
      font-weight: 500;
      font-size: 24px;
    }
    h3 {
      font-size: 14px;
      font-weight: 400;
      line-height: 18px;
      text-align: right;
    }
  }
}
.shop_header {
  justify-content: center;
}
.user {
  padding: 0 24px;
  font-size: 12px;
  margin-bottom: 16px;
  .content {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
    .item {
      width: 45%;
    }
  }
}
.tip {
  padding: 0 24px;
  font-size: 12px;
  line-height: 40px;
}
.table {
  border: 1px solid rgba(215, 215, 215, 1);
  font-size: 12px;
  box-sizing: border-box;
  .head {
    border-bottom: 1px solid rgba(215, 215, 215, 1);
    display: flex;
    line-height: 40px;
    padding: 0 24px;
    p {
      text-align: center;
      flex: 1;
    }
    // .goods_img{
    //   flex: 1.5;
    // }
    .size {
      flex: 1.5;
    }
  }
  .table-list {
    .item-li {
      box-sizing: border-box;
      border-bottom: 1px solid rgba(215, 215, 215, 1);
      position: relative;
      &:last-child {
        border-bottom: none;
      }
      .first_name {
        line-height: 38px;
        margin: 0 24px 6px;
        color: #1a1a1a;
        font-weight: bold;
        border-bottom: 1px dashed #ccc;
      }
      .goods-list {
        display: flex;
        margin: 0 24px 6px;
        border-bottom: 1px dashed #ccc;
        page-break-inside: avoid; //避免在元素内部插入分页符
        &:last-child {
          margin-bottom: 0;
          border-bottom: none;
        }
        .item {
          flex: 1;
          text-align: center;
          padding-top: 6px;
        }
        .img {
          padding-top: 0px;
          img {
            width: 80px;
            height: 80px;
          }
        }
        .size {
          flex: 1.5;
        }
      }
    }
  }
}
.order-total {
  width: 100%;
  display: flex;
  border: 1px solid rgba(215, 215, 215, 1);
  border-top: none;
  align-items: center;
  box-sizing: border-box;
  justify-content: flex-end;
  page-break-inside: avoid; //避免在元素内部插入分页符
  .total-box {
    font-size: 14px;
    margin-right: 30px;
    // width: 200px;
    box-sizing: border-box;
    padding-top: 10px;
    padding-bottom: 10px;
    .total {
      line-height: 24px;
      span {
        display: inline-block;
      }
      b {
        display: inline-block;
        text-align: right;
      }
    }
  }
}
.btn-box {
  text-align: center;
  margin-top: 30px;
  padding-top: 30px;
  padding-bottom: 30px;
  border-top: 2px solid rgba(215, 215, 215, 1);
}
.btn {
  width: 140px;
  height: 36px;
  padding: 0;
  line-height: 36px;
}
.page {
  page-break-after: always;
}
.bold {
  font-weight: bold;
}
.scale {
  transform: scale(0.917);
}
</style>